<template>
  <anchor-modal
    v-model="display"
    width="400"
    :title="title"
    light
    header-color="white"
    :header-split="true"
  >
    <permissions-form
      v-if="display"
      ref="form"
      @cancel="() => display = false"
      @success="successHandler"
    />
  </anchor-modal>
</template>

<script>
import PermissionsForm from '@/components/admin/controls/permissions/form/PermissionsForm';


export default {
  name: 'AdminPermissionsModalForm',
  components: {
    PermissionsForm,
  },
  data: () => ({
    display: false,
    title: '',
  }),
  methods: {
    open(permission) {
      this.display = true;
      this.title = permission ? 'Rename Permission' : 'Add New Permission';
      this.$nextTick(() => {
        this.$refs.form.setModel(permission);
      });
    },
    successHandler() {
      this.$emit('success');
      this.display = false;
    },
  },
};
</script>
